const d3 = Object.assign(
    {},
    require("d3-array"),
    require("d3-selection"),
    require("d3-fetch"),
    require("d3-zoom"),
    require("d3-transition"),
    require("d3-ease"),
    require("d3-voronoi")
)

import { ColParam, Scales, Fn, Action } from "./d3-color-params"
import Helper from "../d3-common"

let bounds

const ColorViz = {
    async loadData(fileName) {
        const theDataSet = await d3.json(`/data/${fileName}.json`)
        console.log(`This dataset contains ${theDataSet.length} photos`)
        return theDataSet
    },

    drawBase(DOMtarget, dataset) {
        ColParam.init(dataset)

        /* Drawing Base = all elements that will remain during updates */
        const dimensions = ColParam.getDimensions(DOMtarget)

        d3.select("#d3-root").remove() // Cleaning for hot refresh

        const wrapper = d3
            .select(`#${DOMtarget}`)
            .append("svg")
            .attr("width", dimensions.width)
            .attr("height", dimensions.height)
            .attr("x", 0)
            .attr("y", 0)
            .attr("class", "wrapper")
            .attr("id", "d3-root")
            .attr("viewBox", [0, 0, dimensions.width, dimensions.height])
            .call(
                d3
                    .zoom()
                    .scaleExtent([0.1, 8])
                    .on("zoom", this.zoomed)
            )

        bounds = wrapper
            .append("g")
            .attr("cursor", "pointer")
            .attr("pointer-events", "all")
            .attr("id", "bounds")
    },

    drawContent(dataset, colourSource) {
        function getC(d) {
            return ColParam.getColor(d, colourSource)
        }

        const tEnterSlow = d3
            .transition()
            .duration(9000)
            .ease(d3.easeCubicOut)

        const dimensions = ColParam.getDimensions("color-viz")
        bounds
            .selectAll("circle")
            .data(dataset)
            .enter()
            .append("circle")
            .attr("cx", dimensions.width / 2)
            .attr("cy", dimensions.height / 2)
            .transition(tEnterSlow)
            .attr("class", "cloud-dot")
            .attr("id", d => `c-${d.id}`)
            .attr("cx", d => {
                const offset = Scales.color(Fn.getValuefromHex(getC(d), "l"))
                return Fn.getCoordinatesFromColor(getC(d), offset)[0]
            })
            .attr("cy", d => {
                const offset = Scales.color(Fn.getValuefromHex(getC(d), "l"))
                return Fn.getCoordinatesFromColor(getC(d), offset)[1]
            })
            .attr("r", d => 2)
            .attr("fill", d => getC(d))

        const voronoiGenerator = d3
            .voronoi()
            .x(d => {
                const offset = Scales.color(Fn.getValuefromHex(getC(d), "l"))
                return Fn.getCoordinatesFromColor(getC(d), offset)[0]
            })
            .y(d => {
                const offset = Scales.color(Fn.getValuefromHex(getC(d), "l"))
                return Fn.getCoordinatesFromColor(getC(d), offset)[1]
            })
            .extent([[0, 0], [dimensions.width, dimensions.height]])

        const voronoiPolygons = voronoiGenerator.polygons(dataset)

        bounds
            .selectAll(".voronoi")
            .data(voronoiPolygons)
            .enter()
            .append("polygon")
            .attr("class", "voronoi")
            .attr("points", (d = []) =>
                d.map(point => point.join(",")).join(" ")
            )
            .attr("fill", "none")
            // .attr("stroke", "grey")
            .on("mouseenter", applyCirclehighlight)
            .on("mouseleave", Action.removeCirclehighlight)
            .on("click", Action.showToolTipVoronoi)

        function applyCirclehighlight(datum, i) {
            // const bounds = d3.select("#bounds")
            bounds
                .append("circle")
                .attr("class", "tooltipDot")
                .attr("cx", d => {
                    const offset = Scales.color(
                        Fn.getValuefromHex(getC(datum.data), "l")
                    )
                    return Fn.getCoordinatesFromColor(
                        getC(datum.data),
                        offset
                    )[0]
                })
                .attr("cy", d => {
                    const offset = Scales.color(
                        Fn.getValuefromHex(getC(datum.data), "l")
                    )
                    return Fn.getCoordinatesFromColor(
                        getC(datum.data),
                        offset
                    )[1]
                })
                .attr("r", 7)
                .attr("fill", "maroon")
                .attr("opacity", 0.5)
                .style("pointer-events", "none")
        }
    },

    zoomed() {
        d3.getEvent = () => require("d3-selection").event
        let k = d3.getEvent().transform.k

        bounds
            .attr("transform", d3.getEvent().transform)
            .selectAll("circle")
            .attr("r", k > 2 ? 4 / k : 2) // circle should never be bigger than 4px

        Action.hideToolTip()
    }
}

export default ColorViz
